<template>
    <div class="m-0 mb-0" :style="skin.main_leagues.body" style="overflow:hidden">
        <div
            v-for="(liga,index) in ligas"
            v-bind:key="index"
            class="p-2"
            style="cursor:pointer"
            @click="select_liga(liga)"
        >
            <span class="rounded-circle me-2" :class="'fi fi-' + country_flag(liga.country_alias)+' fis'" style="height:20px;width:20px"></span>
            <span>{{ liga.name }}</span>
        </div>
    </div>
</template>

<script>
const flags = require('../../../../assets/countries.json');
export default {
    name:"main_ligas3",
    props:["skin","translation","language","sport"],
    data(){
        return{
            ligas_id:[2988,2985,566,1861,543,548,1834,538,545,541,1792
            ],
            ligas_countries:["Brazil","Colombia"],
            selected:[],
            counterSelections:0,
        }
    },
    methods:{
        translate(text) {
            if (this.$props.translation[text]) {
                return this.$props.translation[text][this.$props.language];
            }
            return text;
        },
        select_liga(data){
            this.$store.dispatch('prematch_2/remove_ligas');
            this.$store.dispatch('live/remove_ligas');
            this.$store.dispatch('setLobbyView','prematch2_ligas');
            let payload = {
                league:data.id,
                country:data.country_id,
                league_name:data.name,
                country_name:data.country,
                sport_id:1,
                sport_name:this.translate(data.sport_name.toLowerCase()),
                multiple:true
            };
            this.$store.dispatch('prematch_2/add_remove_liga',payload);
        },
        country_flag(pais) {
          let flag = ""
          flags.countries.forEach(country => {
              if(country.name_es == pais || country.name_en == pais){
                  flag = country.code.toLowerCase()
              }
          });
          return flag;
      }, 
    },
    computed:{
        ligas(){
            var list=[];
            let sports = this.$store.getters['prematch_2/getSports'];
            if(this.$props.skin.main_leagues.target_leagues){
                this.ligas_id = this.$props.skin.main_leagues.target_leagues;
            }
            Object.keys(sports).forEach(sport=>{
                let data = sports[sport];
                if(data ? (data.region ? true : false) : false){
                    if(this.$props.sport?(sport==this.$props.sport?true:false):true)
                    Object.keys(data.region).forEach(region=>{
                        this.ligas_id.forEach(liga_id=>{
                            if(data.region[region].competition ? true : false ){
                                if(liga_id in data.region[region].competition && data.id){
                                    data.region[region].competition[liga_id].country = data.region[region].name;
                                    data.region[region].competition[liga_id].country_alias = data.region[region].alias;
                                    data.region[region].competition[liga_id].country_name = data.region[region].name;
                                    data.region[region].competition[liga_id].sport_id = data.id;
                                    data.region[region].competition[liga_id].country_id = data.region[region].id;
                                    data.region[region].competition[liga_id].sport_name = data.alias;
                                    list.push(data.region[region].competition[liga_id]);
                                }
                            }
                        }); 
                    });
                }
            })
            if(this.counterSelections<1 && list.length>0){
                this.selected.push(list[0].id)
                this.counterSelections++;
            }
            return list;
        },
    }
}
</script>

<style>

</style>